import {
  IconWarning20,
  LabeledContent,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { Addresses } from '../address/Addresses'
import { AutotaxErrors } from '../AutotaxErrors'
import { EmptyAddress } from '../address/EmptyAddress'
import {
  LineItemFulfilmentAddressProps,
  useLineItemFulfilmentAddressModel,
} from './useLineItemFulfilmentAddressModel'

export const LineItemFulfilmentAddress: React.FC<LineItemFulfilmentAddressProps> = props => {
  const model = useLineItemFulfilmentAddressModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-col gap-4">
        {model.showEmptyAddressButton ? (
          <EmptyAddress
            isModalOpeningOnError={props.isModalOpeningOnError}
            hasError={Boolean(model.error)}
            addressStatus={model.status}
            lineItemLocalId={props.lineItemLocalId}
            onSave={props.onSave}
          />
        ) : (
          <Addresses
            isSameBillingAddress={model.isSameBillingAddress}
            formattedShippingAddress={model.formattedShippingAddress}
            formattedBillingAddress={model.formattedBillingAddress}
            isModalOpeningOnError={props.isModalOpeningOnError}
            hasError={Boolean(model.error)}
            addressStatus={model.status}
            fulfilmentDetail={props.fulfillmentDetail}
            onSave={props.onSave}
            lineItemLocalId={props.lineItemLocalId}
          />
        )}
        {model.shouldShowError && model.errorMessage && (
          <LabeledContent
            appearance="danger"
            customClasses={{
              container: 'justify-start',
              content: 'text-left',
            }}
            prefixSlot={<IconWarning20 aria-hidden />}
            size="small"
          >
            {model.errorMessage}
          </LabeledContent>
        )}
        <AutotaxErrors countryId={model.autotaxCountryId} />
      </div>
    </div>
  )
}
